module.exports = __webpack_public_path__ + "static/media/GDPR_candidates.ab31494a.pdf";